import {getDataWithPromise, handleAjaxError} from "root/DataFunctions/BaseDataFns";


export const getSIMSLatestForSchool = (school_id, user_type, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/school/' + school_id + '/simslatest?user_type=' + user_type;

    return getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc(data);
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getSIMSLoadSchools = (onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/simsload/schools';

    return getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc(data);
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const manuallyAssignAsTeacherForWonde = (enc_school_id, data, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/simsload/schools/' + enc_school_id +'/teacher';

    return getDataWithPromise(url, 'PUT', {data}).then(data =>
    {
        onCompleteFunc(data);
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}



